import service from './config'
class SetupService {
    getSetupList() {
        return service.get('api/TroopsConfig/TabletGetTroopsConfig')
    }
    GetConfig(){
        return service.get('api/Config/GetConfig')
    }
    ConfigEdit(param){
    	return service.post('api/TroopsConfig/TabletUpdate',param)
    }
    FactoryReset(){
    	return service.get('api/TroopsConfig/TabletFactoryReset')
    }
    GetCurrentLocation(){
        return service.get('api/System/GetCurrentLocation')
    }
    GetLoreVersion (){
        return service.get('api/System/GetLoreVersion')
    }
    ChangePassword(param){ 
        return service.post('api/TroopsInfo/TroopChangePassword',param)
    }
    UpdateUserAddress(param){ 
        return service.post('/api/TroopsInfo/UpdateUserAddress',param)
    }
    
}
export default new SetupService()